<template>
	<div class="content bgimg-box" v-if="!uploaded">
		<div class="condition-box" style="white-space: pre-wrap;" v-html="round.round_introduce">
			<!-- <h2 class="title">参赛资格（GBC团队赛）</h2>
      <p>
        1.以四人一组团队形式报名参赛，包括一名队长及三名队员，性别不限<br />
        2.每队可同校或跨校组队，跨校需要确保所属同一个区域，每位选手只能参加一支队伍
      </p> -->
		</div>
		<div class="team-info">
			<h1>团队信息</h1>
			<el-form :model="teamData" label-width="125px">
				<el-form-item label="队伍名称(英文)" required>
					<el-input maxlength="30" show-word-limit placeholder="请输入团队名称(不超过6个单词)" v-model="teamData.name"
						type="text"></el-input>
				</el-form-item>
				<el-form-item label="队伍口号(英文)" required>
					<el-input type="textarea" placeholder="请输入团队口号(不超过20个单词)" v-model="teamData.slogan" maxlength="60"
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="学校logo" required>
					<el-upload
					class="avatar-uploader logo-uploader"
					:headers="uploadHeader"
					:action="imageUrl + '/user/upload'"
					:data="uploadData"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload"
					accept=".jpg,.png,.jpeg"
					>
					<img v-if="teamData.university_logo" :src="imageUrl + teamData.university_logo" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div class="logo-uploader-tip">支持jpg,png格式，图片大小>2MB</div>
				</el-form-item>
				
				<!-- <el-form-item label="赛区" required class="saiqu">
					<el-select v-model="teamData.area" placeholder="请选择赛区" @change="changeCitys">
						<el-option v-for="item in areas" :key="item.id" :value="item.id" :label="item.name"></el-option>
					</el-select>
					<el-tooltip content="Bottom center" placement="bottom" effect="light">
						<div slot="content">华北赛区（北京、天津、河北、山西、辽宁、黑龙江、吉林、内蒙古）<br />华东及西北赛区（上海、江苏、浙江、安徽、山东、江西、陕西、甘肃、宁夏、青海、新疆）
							<br>华南赛区（广东、广西、湖南、福建、海南）
							<br>西南和华中赛区（四川、重庆、河南、湖北、云南、贵州、西藏）
						</div>
						<span class="more">
							了解赛区详情
							<i class="el-icon-question"></i>
						</span>
					</el-tooltip>
				</el-form-item> -->
			</el-form>
		</div>
		
		<div class="member-info">
			<h1>成员信息
				（<span>{{ memberArr.length }}</span>/4）
			</h1>
			<el-button class="add-btn" type="text" @click="toAdd()" icon="el-icon-circle-plus-outline">添加成员</el-button>
			<el-dialog title="添加成员" :visible.sync="dialogFormVisible">
				<div class="condition-box condition-video-box" style="margin-bottom: 30px;">
					<p>
						备注：以上信息将用于江西财经大学入校登记使用，请如实填写。
					</p>
				</div>
				<div class="form-box">
					<el-form :model="memberData" ref="form" label-width="125px" :rules="rules">
						<el-row :gutter="20">
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="真实姓名" prop="name">
									<el-input v-model="memberData.name" placeholder="请输入真实姓名"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="姓名拼音" prop="name_pinyin">
									<el-input v-model="memberData.name_pinyin" placeholder="请输入姓名拼音（如：Huang Dengpan）"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="性别" prop="sex" required>
									<el-radio-group v-model="memberData.sex">
										<el-radio :label="1">男</el-radio>
										<el-radio :label="2">女</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="手机" prop="mobile">
									<el-input v-model="memberData.mobile" placeholder="请输入手机"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="邮箱" prop="email">
									<el-input v-model="memberData.email" placeholder="请输入邮箱"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="身份证号码" prop="id_card">
									<el-input v-model="memberData.id_card" placeholder="请输入身份证号码"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="角色" prop="leader" required>
									<el-radio-group v-model="memberData.leader">
										<el-radio :label="1">队长</el-radio>
										<el-radio :label="2">队员</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="身份" prop="is_cima">
									<el-radio v-model="memberData.is_cima" :label="1">在读CGMA方向班学生</el-radio>
									<el-radio v-model="memberData.is_cima" :label="2">非在读CGMA方向班学生</el-radio>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="CIMA学员ID" prop="cima_sn">
									<el-input v-model="memberData.cima_sn" placeholder="请输入CIMA学员ID"></el-input>
								</el-form-item>
							</el-col>
							<!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="院校所在省份" prop="city">
									<el-select v-model="memberData.city" placeholder="请选择院校所在省份">
										<el-option v-for="item in citys" :key="item.id" :value="item.id"
											:label="item.name"></el-option>
									</el-select>
								</el-form-item>
							</el-col> -->
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="所在学院" prop="university">
									<el-input v-model="memberData.university" placeholder="请输入所在学院"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="专业" prop="major">
									<el-input v-model="memberData.major" placeholder="请输入专业"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="在读年级" prop="grade">
									<el-select v-model="memberData.grade" placeholder="请选择在读年级">
										<el-option v-for="item in grades" :key="item.id" :value="item.id"
											:label="item.name"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="联系地址" prop="address_info">
									<el-input v-model="memberData.address_info" placeholder="请输入详细联系地址"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								<el-form-item label="家长同意书" required>
									<el-upload
										ref="uploadFile"
										class="upload-demo upload-file"
										:action="imageUrl + '/user/upload'"
										:headers="uploadHeader"
										:data="uploadData"
										:show-file-list="false"
										:on-success="uploadSuccess"
										:before-upload="beforeFileUpload"
										accept=".doc,.docx,.jpg,.pdf,.png,.jpeg"
										> 
										<el-button size="small"  plan>点击上传</el-button>
										<span class="tip">支持上传word,pdf,jpg格式的文件</span>
									</el-upload>
									<div class="file-item" v-if="memberData.parent_file_name">
										<div class="file-name">
											{{memberData.parent_file_name }}
										</div>
										<div class="icon" @click="removeFile">
											<i class="el-icon-close"></i>
										</div>
									</div>
								</el-form-item>
							</el-col> 
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<el-form-item >
									<el-button class="y-btn" @click="setMember" size="small" type="primary">确定</el-button>
								</el-form-item>
							</el-col>
						</el-row>
						
						<!-- <el-form-item label="联系地址" prop="address">
							<el-cascader v-model="address" :options="citys" :props="{ expandTrigger: 'hover', value:'id',label:'name', children:'children' }"></el-cascader>
						</el-form-item> -->
					</el-form>
				</div>
			</el-dialog>
			<el-table class="pc-table" :data="memberArr" style="margin-bottom: 10px">
				<el-table-column prop="name" label="姓名" min-width="100px" show-overflow-tooltip> </el-table-column>
				<el-table-column label="角色" min-width="80px" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<el-tag style="background: #f4eff6; color: #733085">{{
							scope.row.leader === 1 ? "队长" : "队员"
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="mobile" label="手机" min-width="100px" show-overflow-tooltip align="center">
				</el-table-column>
				<el-table-column prop="university" label="所在学院" min-width="125px" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="is_cima" label="身份" min-width="120px" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						{{ scope.row.is_cima === 1 ? "在读CIMA方向班学生" : "无" }}
					</template>
				</el-table-column>
				<el-table-column prop="cima_sn" label="CIMA学员ID" min-width="80px" show-overflow-tooltip align="center">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="address_info" label="联系地址" min-width="120px"
					show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" width="120px" align="center">
					<template slot-scope="scope">
						<span class="edit" @click="toEdit(scope.row, scope.$index)">编辑</span>
						<span class="del" @click="del(scope.$index)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="mobile-list">
				<div class="item" v-for="(item,index) in memberArr" :key="index">
					<div class="info">
						<div class="label">姓名</div>
						<div class="value">{{ item.name }}</div>
					</div>
					<div class="info">
						<div class="label">手机</div>
						<div class="value">{{ item.mobile }}</div>
					</div>
					<div class="info">
						<div class="label">所在学院</div>
						<div class="value">{{ item.university }}</div>
					</div>
					<div class="info">
						<div class="label">身份</div>
						<div class="value">{{ item.is_cima === 1 ? "在读CIMA方向班学生" : "无" }}</div>
					</div>
					<div class="info">
						<div class="label">CIMA学员ID</div>
						<div class="value">{{ item.cima_sn }}</div>
					</div>
					<div class="info">
						<div class="label">联系地址</div>
						<div class="value">{{ item.address_info }}</div>
					</div>
					<div class="tag">
						<el-tag style="background: #f4eff6; color: #733085">{{
							item.leader === 1 ? "队长" : "队员"
						}}</el-tag>
					</div>
					<div class="bottom-btn">
						<div class="btn" @click="toEdit(item, index)">编辑</div>
						<div class="btn" @click="del(index)">删除</div>
					</div>
				</div>
			</div>
			<h1>指导老师</h1>
			<el-button class="add-btn" type="text" @click="toAddTeacher()" icon="el-icon-circle-plus-outline">添加指导老师</el-button>
			<el-table class="pc-table" :data="teacherData" style="margin-bottom: 10px">
				<el-table-column prop="name" label="姓名" min-width="100px" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机" min-width="100px" show-overflow-tooltip align="center">
				</el-table-column>
				<el-table-column prop="id_card" label="身份证号" min-width="100px" show-overflow-tooltip align="center">
				</el-table-column>
				<el-table-column label="操作" width="120px" align="center">
					<template slot-scope="scope">
						<span class="edit" @click="toEditTeacher(scope.row, scope.$index)">编辑</span>
						<span class="del" @click="delTeacher(scope.$index)">删除</span>
					</template>
				</el-table-column>
			</el-table> 
			<div class="mobile-list">
				<div class="item" v-for="(item,index) in teacherData" :key="index">
					<div class="info">
						<div class="label">姓名</div>
						<div class="value">{{ item.name }}</div>
					</div>
					<div class="info">
						<div class="label">手机</div>
						<div class="value">{{ item.phone }}</div>
					</div>
					<div class="info">
						<div class="label">身份证号</div>
						<div class="value">{{ item.id_card }}</div>
					</div>
					<div class="bottom-btn">
						<div class="btn" @click="toEditTeacher(item, index)">编辑</div>
						<div class="btn" @click="delTeacher(index)">删除</div>
					</div>
				</div>
			</div>
					
			<el-checkbox v-model="accept">同意并接受 <el-link target="_blank"
					href="https://www.cimaglobal.com/Privacy-Policy/">CIMA隐私政策</el-link>
			</el-checkbox>
			<div class="team-button-box">
				<!-- <el-button class="pre">上一步</el-button> -->
				<el-button class="pre" @click="sub" size="small" type="primary">提交</el-button>
			</div>
		</div>
		

		<!-- <div class="bg-pic-box">
      <img src="../../assets/images/team/bg.png" alt="" />
    </div> -->
	<el-dialog  custom-class="dialog_tc" title="添加指导老师" :visible.sync="teacherDialog" width="480px">
		<div class="condition-box condition-video-box" style="margin-bottom: 30px; padding: 10px 15px;">
			<p>
				备注：以上信息将用于江西财经大学入校登记使用，请如实填写。
			</p>
		</div>
		<div class="form-box rules-form">
			<el-form :model="teacherForm" ref="teacherForm" label-width="80px" :rules="teacherRules">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="teacherForm.name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="teacherForm.phone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="id_card">
					<el-input v-model="teacherForm.id_card" placeholder="请输入身份证号"></el-input>
				</el-form-item>
				<el-form-item label-width="0px" style="text-align: center;margin-top: 20px;">
					<el-button style="margin-bottom: 0px;" class="y-btn" @click="setTeacher" size="small" type="primary">确定</el-button>
				</el-form-item>
			</el-form>
		</div>
	</el-dialog>
	</div>
	<div class="status-box" v-else>
		<!-- <div class="file-box" style="padding: 0 30px;margin: 0;">
			<div class="demo">
				<p>
					点击<el-button type="text" @click="downloadTempalate('anli')">下载《案例》</el-button>
				</p>
				<p>
					点击<el-button type="text" @click="downloadTempalate('timu')">下载《案例题目》</el-button>
				</p>
			</div>
		</div> -->
		<div class="img-box">
			<img src="../../assets/images/team/submit.png" alt="" />
			<p>报名信息已提交成功！</p>
			<!-- <el-button class="next">下一步</el-button> -->
		</div>
	</div>
</template>

<script>
import {
	apiGetUserInfo,
	apiGetCity,
	apiSetReportTeamDataTeam,
	apiGetReportTeamData,
	apiSetProcess,
} from '../../plugins/apis'
export default {
	data() {
		return {
			uploadHeader:{ Authorization: window.localStorage.app_token },
			imageUrl: process.env.VUE_APP_API_URL,
			uploadData:{file_source:1},
			loading: true,
			memberArr: [],
			teacherData:[],
			uploaded: false,
			grades: [
				{ id: 1, name: '大一' },
				{ id: 2, name: '大二' },
				{ id: 3, name: '大三' },
				{ id: 4, name: '大四' },
			],
			rules: {
				name: [
					{
						required: true,
						message: "请输入真实姓名",
						trigger: ["blur", "change"],
					},
				],
				name_pinyin: [
					{
						required: true,
						message: "请输入姓名拼音",
						trigger: ["blur", "change"],
					},
				],
				mobile: [
					{
						required: true,
						validator: (rule, value, callback) => {
							let mobileNumRegx = new RegExp(/^1[3456789]{1}[0-9]{9}$/);
							if (value === "") {
								callback(new Error("请输入手机号码"));
							} else if (!mobileNumRegx.test(value)) {
								callback(new Error("手机号码格式不正确"));
							} else {
								callback();
							}
						},
						trigger: ["blur", "change"],
					},
				],
				email: [
					{
						required: true,
						message: "请输入邮箱",
						trigger: ["blur", "change"],
					},
				],
				id_card: [
					{
						required: true,
						message: "请输入身份证号码",
						trigger: ["blur", "change"],
					},
				],
				university: [
					{
						required: true,
						message: "请输入所在学院",
						trigger: ["blur", "change"],
					},
				],
				major: [
					{
						required: true,
						message: "请输入专业",
						trigger: ["blur", "change"],
					},
				],
				grade: [
					{
						required: true,
						message: "请输入在读年级",
						trigger: ["blur", "change"],
					},
				],
				// city: [
				// 	{
				// 		required: true,
				// 		message: "请选择院校所在省份",
				// 		trigger: ["blur", "change"],
				// 	},
				// ],
				is_cima: [
					{
						required: true,
						message: "请选择身份",
						trigger: ["blur", "change"],
					},
				],
				address_info: [
					{ required: true, message: "请输入联系地址", trigger: ["blur", "change"] },
				],

			},
			
			teacherRules: {
				name: [
					{
						required: true,
						message: "请输入姓名",
						trigger: ["blur", "change"],
					},
				],
				phone: [
					{
						required: true,
						validator: (rule, value, callback) => {
							let mobileNumRegx = new RegExp(/^1[3456789]{1}[0-9]{9}$/);
							if (value === "") {
								callback(new Error("请输入手机号码"));
							} else if (!mobileNumRegx.test(value)) {
								callback(new Error("手机号码格式不正确"));
							} else {
								callback();
							}
						},
						trigger: ["blur", "change"],
					},
				],
				
				id_card: [
					{
						required: true,
						message: "请输入身份证号码",
						trigger: ["blur", "change"],
					},
				],

			},
			account_id: '',
			memberData: {
				name: "",
				sex: 1,
				university: "",
				major: "",
				grade: "",
				city: "",
				mobile: "",
				email: "",
				is_cima: 1,
				cima_sn: "",
				leader: 2,
				address_info: '',
				parent_file:'',
				parent_file_name:'',
			},
			areas: [
				{ id: 1, name: '华北赛区' },
				{ id: 2, name: '华东及西北赛区' },
				{ id: 3, name: '华南赛区' },
				{ id: 4, name: '西南和华中赛区' },
			],
			teamData: {
				name: '',
				slogan: '',
				area: '1',
				university_logo:'',
			},
			dialogFormVisible: false,
			formLabelWidth: "125px",
			isEdit: false,
			isTeacherEdit: false,
			editIndex: "",
			editTeacherIndex: "",
			citys: [],
			address: [],
			accept: false,
			teacherDialog:false,
			teacherForm:{},
		};
	},
	watch: {
		round() {
			this.getSyncData()
		},
		dialogFormVisible() {
			if (this.dialogFormVisible === false) {
				this.memberData = {
					name: "",
					sex: 1,
					university: "",
					major: "",
					grade: "",
					city: "",
					mobile: "",
					email: "",
					is_cima: 1,
					cima_sn: '',
					leader: 2,
					parent_file:'',
					parent_file_name:'',
				}
			}
		},

	},
	methods: {
		handleChange(value) {
		console.log(88,value); // 这里的value是选中项的id数组
		},
		
		downloadTempalate(flag) {
			switch (flag) {
				case "report":
					window.open("http://api.gbc.cncima.com/download?path=" + encodeURIComponent("/storage/2024 GBC Report Template.docx"));
					// window.open('http://api.gbc.cncima.com/storage/CGMA%20GBC2022%E5%9B%A2%E9%98%9F%E6%8A%A5%E5%91%8A%E6%A8%A1%E6%9D%BF.docx')
					break;
				case "ppt":
					window.open("http://api.gbc.cncima.com/download?path=" + encodeURIComponent("/storage/2024 GBC PPT Template.pptx"));
					// window.open('http://api.gbc.cncima.com/storage/GBC2022%20%20PPT%20template%2016-9.pptx')
					break;
				case "anli":
					window.open("http://api.gbc.cncima.com/download?path=" + encodeURIComponent("/storage/GBC Case.pdf"));
					// window.open('http://api.gbc.cncima.com/storage/GBC%20Case.pdf')
					break;
				case "timu":
					window.open("http://api.gbc.cncima.com/download?path=" + encodeURIComponent("/storage/Questions_Mainland China Final.pdf"));

					// window.open('http://api.gbc.cncima.com/storage/Questions_Mainland%20China%20Final.pdf')
					break;
			}
		},
		
		async changeCitys(id = true) {
			if (id) {
				let res = await apiGetCity(0);
				if (res.code === 200) {
					this.citys = res.data;
					console.log(11, this.citys)
				}
			} else {
				this.citys = []
			}

		},
		handleAvatarSuccess(res) {
			if(res.code === 200){
				this.$set(this.teamData,'university_logo',res.data.file.path)
				this.$message.success('上传成功')
			}
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

			// const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isJPG) {
				this.$message.error("上传图片只能是 JPG或者PNG 格式!");
			}
			// if (!isLt2M) {
			// 	this.$message.error("上传图片大小不能超过 2MB!");
			// }
			// return isJPG && isLt2M;
			return isJPG;
		},
		beforeFileUpload(file) { 
			let fileArr = file.name.split('.')
			let bul = ['doc','docx','jpg','pdf','png'].indexOf(fileArr.pop()) > -1
			if(bul) {
				return true;
			}else{
				this.$message.error('只能上传word,pdf,jpg文件')
				return false
			}
		},
		uploadSuccess(e){
			if(e.code === 200){
				this.$message.success('上传成功')
				this.$set(this.memberData,'parent_file',e.data.file.path)
				this.$set(this.memberData,'parent_file_name',e.data.file.name)
				console.log('file',e.data)
			}else[
				this.$message.error('上传失败')
			]
		},
		removeFile(){
			this.memberData.parent_file = ''
			this.memberData.parent_file_name = ''
		},
		toAdd() {
			if (this.memberArr.length >= 4) {
				this.$message.error('最多四名队员参赛')
			} else {
				this.dialogFormVisible = true
			}
		},
		toAddTeacher(){
			this.teacherForm = {}
			this.teacherDialog = true
		},
		del(i) {
			this.memberArr.splice(i, 1)
		},
		async getTeam() {
			let res = await apiGetReportTeamData(this.round.round_id)
			if (res.code === 200) {
				this.teamData = Array.isArray(res.data.teamData) ? {} : res.data.teamData
				this.memberArr = res.data.memberData || []
				this.uploaded = this.memberArr.length > 0
			}
		},
		toEdit(data, i) {
			this.memberData = JSON.parse(JSON.stringify(data));
			this.editIndex = i;
			this.dialogFormVisible = this.isEdit = true;
		},
		toEditTeacher(data, i) {
			this.teacherForm = JSON.parse(JSON.stringify(data));
			this.editTeacherIndex = i;
			this.teacherDialog = this.isTeacherEdit = true;
		},
		delTeacher(i) {
			this.teacherData.splice(i, 1)
		},
		async sub() {
			if (this.teamData.name === '') {
				this.$message.error('请填写团队名称')
				return
			}
			if (this.teamData.slogan === '') {
				this.$message.error('请填写团队口号')
				return
			}
			if (this.teamData.university_logo === '') {
				this.$message.error('请上传学校logo')
				return
			}

			if (this.teamData.name.length > 30) {
				this.$message.error('团队名称不超过30个字符')
				return
			}

			if (this.teamData.slogan.length > 60) {
				this.$message.error('团队口号不超过60个字符')
				return
			}
			// if (this.teamData.area === '') {
			// 	this.$message.error('请选择赛区')
			// 	return
			// }
			if (this.memberArr.length !== 4) {
				this.$message.error('您的团队人数不足四人')
				return
			}
			if (!this.accept) {
				this.$message.error('请同意并接受相关隐私政策')
				return
			}
			let leaderNum = 0;
			for (let item of this.memberArr) {
				if (item.leader === 1) {
					++leaderNum
				}
			}
			if (leaderNum < 1) {
				this.$message.error('请设置至少一个队长')
				return
			}
			if (leaderNum > 1) {
				this.$message.error('请设置一个队长')
				return
			}
			await this.apiSetReportTeamDataTeam()
		},
		async apiSetReportTeamDataTeam() {
			let res = await apiSetReportTeamDataTeam(this.round.round_id, this.teamData, this.memberArr, this.teacherData)
			if (res.code === 200) {
				this.$message.success('保存成功')
				await apiSetProcess(this.round.round_id, this.label)
				this.$Bus.$emit('reload_NowProcess');
				this.view();
			} else {
				this.$message.error(res.message)
			}
		},
		setMember() {
			this.$refs.form.validate(async (valid) => {
				if (!this.memberData.parent_file) {
					this.$message.error('请上传同意书')
					return
				}
				if (valid) {
					if (this.isEdit) {
						this.memberArr.splice(this.editIndex, 1, this.memberData)
						this.editIndex = ''
						this.dialogFormVisible = this.isEdit = false
					} else {
						this.memberArr.push(this.memberData)
						this.dialogFormVisible = this.isEdit = false
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		setTeacher() {
			this.$refs.teacherForm.validate(async (valid) => {
				
				if (valid) {
					if (this.isTeacherEdit) {
						this.teacherData.splice(this.editIndex, 1, this.teacherForm)
						this.editTeacherIndex = ''
						this.teacherDialog = this.isEdit = false
					} else {
						this.teacherData.push(this.teacherForm)
						this.teacherDialog = this.isTeacherEdit = false
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},

		async getCity() {
			let res = await apiGetCity(0);
			if (res.code === 200) {
				this.citys = res.data;
				console.log(11, this.citys)
			}
		},
		getSyncData() {
			if (window.localStorage.getItem('cima_teamData_sync' + this.round.round_id + this.account_id)) {
				this.teamData = JSON.parse(window.localStorage.getItem('cima_teamData_sync' + this.round.round_id + this.account_id))
			}
			if (window.localStorage.getItem('cima_memberArr_sync' + this.round.round_id + this.account_id)) {
				this.memberArr = JSON.parse(window.localStorage.getItem('cima_memberArr_sync' + this.round.round_id + this.account_id))
			}
			if (window.localStorage.getItem('cima_teacherArr_sync' + this.round.round_id + this.account_id)) {
				this.teacherData = JSON.parse(window.localStorage.getItem('cima_teacherArr_sync' + this.round.round_id + this.account_id))
			}
		},
		async view() {
			this.loading = true
			let nn = await apiGetUserInfo()
			if (nn.code === 200) {
				this.account_id = nn.data.account_id
			}
			await this.getCity()
			await this.getTeam()

			this.getSyncData()
			console.log('cima_teamData_sync' + this.round.round_id + this.account_id)
			setInterval(() => {
				if (this.teamData) {
					window.localStorage.setItem('cima_teamData_sync' + this.round.round_id + this.account_id, JSON.stringify(this.teamData))
				}
				if (this.memberArr) {
					window.localStorage.setItem('cima_memberArr_sync' + this.round.round_id + this.account_id, JSON.stringify(this.memberArr))
				}
				if (this.teacherData) {
					window.localStorage.setItem('cima_teacherArr_sync' + this.round.round_id + this.account_id, JSON.stringify(this.teacherData))
				}
			}, 2000)
			this.loading = false
			// await this.changeCitys(0)
		}
	},
	async mounted() {
		await this.view()

	},
	props: ["round", "label"],
};
</script> 

<style scoped>
.bgimg-box {
	background-color: #ffffff !important;
	background: url("../../assets/images/team/bg.png") no-repeat bottom right;
}

.el-textarea {
	width: 442px;
}

.el-tooltip {
	font-size: 12px;
}

.more {
	cursor: pointer;
	margin-left: 5px;
}

.more:hover {
	text-decoration: underline;
	color: #733085;
}
</style>

